import { Component } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router, RouterModule } from '@angular/router';
import { ValidationMessageComponent } from '../../../shared/components/validation-message/validation-message.component';
import { MiddlewareService } from '../../../core/services/middleware.service';
import { apiURL } from '../../../../assets/data/api-url';
import { EmailVerificationComponent } from '../../../shared/components/email-verification/email-verification.component';
import { EmailVerificationResponse } from '../../../core/models/email-verification-response.model';
import { ConfirmPasswordDirective } from '../../../shared/directives/confirm-password.directive';
import { CommonModule } from '@angular/common';
import { TranslateModule } from '@ngx-translate/core';
import { ApiResponse } from '../../../core/enums/api-response.enum';
import { globalDatas } from '../../../../assets/data/globals';
import { EncryptionService } from '../../../core/services/encryption.service';
import { ModalType } from '../../../core/enums/modal-type.enum';
import { ModalService } from '../../../core/services/modal.service';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { TermsAndConditionsComponent } from '../../terms-and-conditions/terms-and-conditions.component';
import { PrivacyPolicyComponent } from '../../privacy-policy/privacy-policy.component';
import { Component_Name } from '../../../core/enums/component-name.enum';
import { CommonService } from '../../../core/services/common.service';
import { NgSelectModule } from '@ng-select/ng-select';

@Component({
  selector: 'app-sign-up',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ValidationMessageComponent,
    EmailVerificationComponent,
    ConfirmPasswordDirective,
    CommonModule,
    TranslateModule,
    RouterModule,
    NgSelectModule
  ],
  templateUrl: './sign-up.component.html',
  styleUrl: './sign-up.component.scss'
})
export class SignUpComponent {
  signUpForm!: FormGroup;
  isSubmitted = false;
  showPassword = false;
  showConfrimPassword = false;
  componentName = 'signUp';
  preferredLanguageList = globalDatas.PREFERRED_LANGUAGE_LIST;
  mobileMaxLimit = globalDatas.MOBILE_NUMBER_MAX_LIMIT;
  componentsName = Component_Name;
  blockedCountriesList = globalDatas.BLOCKED_COUNTRIES_IN_DROPDOWN;
  passwordCustomValidation = { pattern: 'VALIDATION.INVALID_PASSWORD_PATTERN' }
  constructor(
    public router: Router,
    private _fb: FormBuilder,
    private _middlewareService: MiddlewareService,
    private encryptionService: EncryptionService,
    private modalService: ModalService,
    public ngbModal: NgbModal,
    private commonService: CommonService
  ) {
    this.loadSignUpForm();
  }


  loadSignUpForm() {
    this.signUpForm = this._fb.group({
      email: ['', [Validators.required, Validators.email, Validators.pattern(globalDatas.EMAIL_REG_EXP)]],
      password: ['', [Validators.required, Validators.pattern(globalDatas.PASSWORD_REG_EXP)]],
      confirmPassword: ['', [Validators.required]],
      preferredLanguage: [
        this.commonService.systemLanguage ?
          this.commonService.systemLanguage : globalDatas.DEFUALT_PREFERRED_LANGUAGE,
        [Validators.required]],
      termsAndCondition: ['', [Validators.required]],
    });
  }

  onVerifyOTP(emittedData: EmailVerificationResponse) {
    this.signUpForm.get('email')?.setValue(emittedData?.email);
  }

  termsAndConditionChange() {
    if (this.signUpForm.value.termsAndCondition !== true) {
      this.signUpForm.get('termsAndCondition')?.setValue('');
      this.signUpForm.get('termsAndCondition')?.setValidators([Validators.required]);
      this.signUpForm.get('termsAndCondition')?.updateValueAndValidity();
    }
  }

  async onSubmit() {
    this.isSubmitted = true;
    if (this.signUpForm.valid) {
      const { confirmPassword, termsAndCondition, ...signUpPayload } = this.signUpForm.value;
      const encryptedPayload = await this.encryptionService.encryptData(signUpPayload);
      this._middlewareService.callPostMiddleware(`${apiURL.signUp}`, { payload: encryptedPayload }).subscribe((result: any) => {
        if (result?.code === ApiResponse.OK) {
          this.modalService.commonAlertModal('SIGN_UP.SIGN_UP_SUCCESS_MESSAGE', ModalType.SUCCESS);
          this.router.navigate([this.commonService.getRouteStartIndex() + '/sign-in']);
        }
      });
    }
  }

  openModal(name: string) {
    const modalRef = this.ngbModal.open(name === Component_Name.PRIVACY_POLICY ? PrivacyPolicyComponent : TermsAndConditionsComponent, {
      centered: true,
      size: 'xl',
    });
    modalRef.componentInstance.showCloseBtn = true;
  }
}
